module.exports = __webpack_public_path__ + "img/collection-engagementRings.bc4bbf2.jpg";